
















import { Component, Vue } from "vue-property-decorator";
import { AffiliateClientsParam } from "@/data/filters/client";

@Component({
  methods: { AffiliateClientsParam },
  components: {
    "client-search": () =>
      import("@/components/app/global/client/clientSearch.vue")
  }
})
export default class RecentAffiliatesList extends Vue {}
